import { Loader } from './Loader'

export function Loading({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex w-full items-center justify-center min-h-[200px] flex-col gap-2">
      <Loader />
      {children}
    </div>
  )
}
